import { render, staticRenderFns } from "./ElCollapseTransition.vue?vue&type=template&id=e36309aa"
import script from "./ElCollapseTransition.vue?vue&type=script&lang=js"
export * from "./ElCollapseTransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports